import { combineReducers } from 'redux';
import menu from './menu/reducer';

const reducer = combineReducers({
  menu,
});

export default reducer;
